// extracted by css-extract-rspack-plugin
export default {"BaseCell":"row-dragger-module__BaseCell__xM_Uw","Box":"row-dragger-module__Box__dnhHC","IconButton":"row-dragger-module__IconButton__pRPwL"};